import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import { useNavigate } from "react-router-dom";

import "./Pages.css";

const Quantisys360 = () => {
  const navigate = useNavigate();
  
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="page-container">
        <h1>Quantisys360: The Future of Healthcare</h1>
          <p>
            Quantisys360 is an advanced Electronic Medical Records (EMR) system designed for hospitals, clinics, and healthcare providers. Our platform streamlines patient management, enhances clinical efficiency, and ensures secure, real-time access to medical data.
          </p>

          <h2>Why Choose Quantisys360?</h2>
          <p>
            - Cloud-Based & Secure: Access patient records anytime, anywhere with enterprise-grade security. <br />
            - Intelligent Analytics: AI-driven insights help healthcare providers make data-backed decisions. <br />
            - Customizable Workflow: Tailored to fit the needs of small clinics to large hospitals. <br />
            - Seamless Integration: Compatible with insurance, billing, lab reports, and diagnostic tools. <br />
            - Multi-Hospital Support: Each hospital or clinic gets a separate, private database, ensuring data privacy. <br />
            - User-Friendly Interface: Minimal training required with an intuitive, modern dashboard.
          </p>

        <button className="page-button" onClick={() => navigate("/learn-more/quantisys360")}>Learn More</button>
      </div>
    </motion.div>
  );
};

export default Quantisys360;
